import { api } from '../api/client.js';
import { ENDPOINTS } from '../api/endpoints.js';
import { API_CONFIG } from '../api/config.js';
import { mockPerformance, mockStreak } from '../mocks/stats.js';
import { getRecentScenarioActivity } from '../utils/activityStore.js';

const delay = (ms = 150) => new Promise((r) => setTimeout(r, ms));

export const statsService = {
  async getDeadlines() {
    try {
      const scenarios = await api.get(ENDPOINTS.scenarios.list());
      return (scenarios || []).slice(0, 2).map((scenario, index) => ({
        id: scenario.id || `task-${index}`,
        title: {
          ar: scenario.title_ar || scenario.title_en,
          en: scenario.title_en || scenario.title_ar,
        },
        subtitle: {
          ar: String(scenario.challenge || scenario.scenario_context || '').slice(0, 120),
          en: String(scenario.challenge || scenario.scenario_context || '').slice(0, 120),
        },
        date: { ar: `مهمة ${index + 1}`, en: `Task ${index + 1}` },
      }));
    } catch {
      await delay(); return [];
    }
  },
  async getRecents() {
    const localRecents = getRecentScenarioActivity();
    if (localRecents.length) {
      return localRecents.map((item) => ({
        id: item.id,
        icon: 'ic-play',
        title: { ar: item.titleAr, en: item.titleEn },
        time: { ar: 'تم فتح السيناريو', en: 'Scenario opened' },
      }));
    }
    if (API_CONFIG.useMocks) { await delay(); return []; }
    try {
      const stats = await api.get(ENDPOINTS.stats.recents());
      const recents = stats.recent_activity || [];
      if (!recents.length) return [];
      return recents.slice(0, 5).map((r, i) => ({
        id: r.id || `r${i}`,
        icon: 'ic-book2',
        title: { ar: r.scenario_title, en: r.scenario_title },
        time: { ar: String(r.created_at || ''), en: String(r.created_at || '') },
      }));
    } catch {
      await delay(); return [];
    }
  },
  async getPerformance() {
    if (API_CONFIG.useMocks) { await delay(); return mockPerformance; }
    try {
      const stats = await api.get(ENDPOINTS.stats.performance());
      return {
        performancePercent: stats.mastery_rate || 0,
        progressPercent: Math.min(100, (stats.total_attempts || 0) * 10),
      };
    } catch {
      await delay(); return mockPerformance;
    }
  },
  async getStreak() {
    if (API_CONFIG.useMocks) { await delay(); return mockStreak; }
    try {
      const stats = await api.get(ENDPOINTS.stats.streak());
      return { days: stats.streak || 0, active: (stats.streak || 0) > 0 };
    } catch {
      await delay(); return mockStreak;
    }
  },
};
